/**
 * Created by juan on 08/03/17.
 */

export class MenuEntry {

    id: number;

    label: string;

    icon: string = null;

    parentId: number = null;

    constructor(value: Object = {}) {
        Object.assign(this, value);
    }

}

export const menuEntries: MenuEntry[] = [
    new MenuEntry({id: 1, label: 'Inicio', icon: 'home'}),
    new MenuEntry({id: 2, label: 'Administracion', icon: 'computer'}),
    new MenuEntry({id: 3, label: 'Usuarios', icon: 'people_outline', parentId: 2}),
    new MenuEntry({id: 4, label: 'Roles', icon: 'security', parentId: 2}),
    new MenuEntry({ id: 19, label: 'Ministerios', icon: 'business', parentId: 2 }),
    new MenuEntry({id: 5, label: 'Dictámenes', icon: 'description'}),
    new MenuEntry({id: 7, label: 'Categorias', icon: 'folder_special', parentId: 5}),
    new MenuEntry({id: 8, label: 'Biblioteca', icon: 'cloud'}),
    new MenuEntry({id: 9, label: 'Leyes', icon: 'folder', parentId: 8}),
    new MenuEntry({id: 10, label: 'Doctrina', icon: 'folder', parentId: 8}),
    new MenuEntry({id: 11, label: 'Jurisprudencia', icon: 'folder', parentId: 8}),
    new MenuEntry({id: 11, label: 'Jurisprudencia', icon: 'folder', parentId: 8}),
    new MenuEntry({id: 12, label: 'Foro de consultas', icon: 'forum'}),
    new MenuEntry({id: 13, label: 'Tópicos', icon: 'stars', parentId: 2}),
    //new MenuEntry({id: 14, label: 'Perfiles', icon: 'people'}),
    new MenuEntry({id: 15, label: 'Dictámenes modelo', icon: 'library_books', parentId: 5}),
    new MenuEntry({id: 16, label: 'Mis dictámenes', icon: 'class', parentId: 5}),
    new MenuEntry({id: 17, label: 'Solicitudes de registro', icon: "person_add", parentId: 2}),
    new MenuEntry({id: 18, label: 'Mensajeria interna', icon: "mail"}),
    new MenuEntry({id: 20, label: 'Perfiles', icon: 'people'}),
    new MenuEntry({id: 21, label: 'Reportar errores', icon: "report"}),
    new MenuEntry({id: 22, label: 'Vistas modelo', icon: 'library_books'}),
    new MenuEntry({id: 23, label: 'Vistas modelo', icon: 'description',  parentId: 22}),
    new MenuEntry({id: 24, label: 'Vistas modelo completadas', icon: 'class',  parentId: 22}),


];



// WEBPACK FOOTER //
// ./src/app/core/domain/menu-entry.ts